import { Component, OnInit } from '@angular/core';
import{ SharedService } from '../../services/shared.service';
import { FormGroup, FormControl,  FormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { OnlineSchedulingConfirmComponent } from '../online-scheduling/online-scheduling-confirm/online-scheduling-confirm.component'
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {CommonService} from '../../../modules/reports/services/common/common.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-online-scheduling',
  templateUrl: './online-scheduling.component.html',
  styleUrls: ['./online-scheduling.component.scss']
})
export class OnlineSchedulingComponent implements OnInit {
public old_site;
  wantsForm = this.fb.group({
	branch: [''],
  });
  wantsEarlier=[];
  branches=[];
  noData=false;
  displayData=false;
  inspectors : any = [];
  jobCreatedId = "";
  constructor(	
  	private sharedService:SharedService, 
  	private fb: FormBuilder,
  	config: NgbModalConfig, 
  	private modelService: NgbModal,
  	private commonService: CommonService
  	) { }
  ngOnInit() {
  	this.getInspectors();
	this.onSubmit();
	this.old_site = environment.apiSite;
  }
  	getInspectors(){
	    this.commonService.getInspectors().subscribe(
	      data => { 
	                this.inspectors = data;
	              }
	    );
	  }
  openpop(id){
  	const modalRef = this.modelService.open(OnlineSchedulingConfirmComponent, { size: 'lg' });
    modalRef.componentInstance.inspectionData = id;
    modalRef.componentInstance.inspectors = this.inspectors
    modalRef.result.then((result) => {
        this.onSubmit();
    }).catch((error) => {
    	this.onSubmit();
    });
  }
  onSubmit(){
	this.displayData=true;
	this.sharedService.getOnlineBookings().subscribe(
	  data => { 
			  // this.branches = data;
			  this.wantsEarlier = data;
			  console.log(data);
			  if(data.length>0){
				this.noData=false;
			  } else{
				this.noData=true;
			  }
			}
	);
  }
  cardDelete(job){
    Swal({
		title: 'Warning',
		text: 'Do You Want To Discard?',
		type: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes'
	})
	.then((result) => {
		if (result.value) {
		console.log(result)
		  this.sharedService.discardOnlineBookingJob({id:job.id})
		  .subscribe(
		      data => {
		          this.onSubmit();
		      }, error => {
		          this.onSubmit();
		      }
		  );
		}
	})
    
  }
  route(link){
	console.log(this.old_site)
	window.location.href = this.old_site.url+'/inspections_completed_sheet/'+link; 
  }
  reset(){
	// this.wantsForm.reset()
	this.wantsForm.patchValue({
	  branch: ''
	});
  }

}
